// Ícones de traço simples (no lugar dos emojis de bonequinhos), iguais no Android, iPhone e navegador.
import Svg, { Circle, Path } from 'react-native-svg';

/** Pessoa com "+" (amigos). */
export const IconeAmigos = ({ cor, tam = 20 }: { cor: string; tam?: number }) => (
  <Svg width={tam} height={tam} viewBox="0 0 24 24" fill="none" stroke={cor} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <Circle cx={9} cy={8} r={4} />
    <Path d="M2 21c0-3.9 3.1-7 7-7s7 3.1 7 7" />
    <Path d="M19 8v6M16 11h6" />
  </Svg>
);
/** Balão de conversa com "+" (nova conversa). */
export const IconeNovaConversa = ({ cor, tam = 20 }: { cor: string; tam?: number }) => (
  <Svg width={tam} height={tam} viewBox="0 0 24 24" fill="none" stroke={cor} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <Path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z" />
    <Path d="M12 8.5v7M8.5 12h7" />
  </Svg>
);
